// extracted by mini-css-extract-plugin
export default {"drawer":"CreateUser_drawer__BO3Oh"};